import React from 'react'
import { Typography, Button, Space } from 'antd'
import { PlusOutlined, SortAscendingOutlined } from '@ant-design/icons'

const { Title, Text } = Typography

type RoomSectionHeaderProps = {
  onCreateRoom: () => void
  isSortMode: boolean
  onToggleSortMode: () => void
}

const RoomSectionHeader: React.FC<RoomSectionHeaderProps> = ({
  onCreateRoom,
  isSortMode,
  onToggleSortMode,
}) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
      <div>
        <Title level={3} style={{ margin: 0 }}>Room Details</Title>
        <Text type="secondary">Manage your hotel rooms and amenities</Text>
      </div>
      <Space>
        <Button
          icon={<SortAscendingOutlined />}
          type={isSortMode ? 'primary' : 'default'}
          onClick={onToggleSortMode}
        >
          Sort Order
        </Button>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={onCreateRoom}
          style={{ display: 'none' }}
        >
          Create Room
        </Button>
      </Space>
    </div>
  )
}

export default RoomSectionHeader
